import React, { useEffect } from "react";
import {
  EnvelopeCheck,
  Envelope,
  Link45deg,
  InfoCircle,
} from "react-bootstrap-icons";
import "./unauthPayoff.css";
import { useLocation, useNavigate } from "react-router-dom";

const UnauthorizeLink = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!location.state?.displayPage) {
      navigate("/login");
    }
  }, []);
  
  return (
    <div className="access-required-page text-start">
      <div className="access-required-card">
        <div className="access-required-icon">
          <EnvelopeCheck size={42} />
        </div>

        <h1>Access Your Payoff Authorization</h1>

        <p className="access-required-description">
          An email invitation is required to access your payoff authorization
          request.
        </p>

        <div className="access-required-divider" />

        <div className="access-required-step">
          <Envelope size={22} />
          <div>
            <h3>Check your email</h3>
            <p>
              Locate the payoff authorization email sent to your registered
              email address.
            </p>
          </div>
        </div>

        <div className="access-required-step">
          <Link45deg size={22} />
          <div>
            <h3>Open your secure link</h3>
            <p>
              Use the link provided in the email to access your authorization
              request.
            </p>
          </div>
        </div>

        <div className="access-required-help">
          <InfoCircle size={20} />
          <div>
            <strong>Need assistance?</strong>
            <p>
              Contact our support team if you need help accessing your request.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizeLink;
